import Image from 'next/image';
import { useSafeZoneState } from '../lib/use-safe-zone-state';
import { useDimensions } from '../utils/use-context';
import { SafeZonePlatform } from '../state/types';

const SAFE_ZONE_IMAGES: Record<SafeZonePlatform, string> = {
  instagram: '/res/img/safety-guide/instagram_safety_guide.png',
  tiktok: '/res/img/safety-guide/tiktok_safety_guide.png',
  youtube: '/res/img/safety-guide/youtube_safety_guide.png',
  gsshop: '/res/img/safety-guide/gsshop_safety_guide.png',
};

export const SafeZoneOverlay = () => {
  const { safeZoneGuide } = useSafeZoneState();
  const { compositionWidth, compositionHeight } = useDimensions();

  // 9:16 비율일 때만 표시 (1080x1920)
  const is9by16 = compositionWidth === 1080 && compositionHeight === 1920;

  if (!safeZoneGuide.enabled || !is9by16) {
    return null;
  }

  const imageSrc = SAFE_ZONE_IMAGES[safeZoneGuide.platform];

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 10,
      }}
    >
      <Image
        src={imageSrc}
        alt={`${safeZoneGuide.platform} safe zone guide`}
        fill
        style={{
          objectFit: 'fill',
          pointerEvents: 'none',
        }}
      />
    </div>
  );
};
